// components
import { Stake, Unstake, Claim } from "components";

// firebase analytics
import { firebaseEvents } from "utils/firebase";
import { FIREBASE_EVENT_PROPERTIES } from "constants/constants";

const sendLog = (name: string) => {
  let firebaseRequest: any = {
    [FIREBASE_EVENT_PROPERTIES.EVENT_NAME]: name,
    [FIREBASE_EVENT_PROPERTIES.WALLET_NAME]: null,
    [FIREBASE_EVENT_PROPERTIES.WALLET_ADDRESS]: null,
  };
  firebaseEvents(firebaseRequest);
};
const stakingTabsData = [
  {
    title: "Stake",
    body: <Stake />,
    trackTabClickEvent: () => {
      sendLog("Stake_Tab");
    },
  },
  {
    title: "Unstake",
    body: <Unstake />,
    trackTabClickEvent: () => {
      sendLog("Unstake_Tab");
    },
  },
  {
    title: "Withdraw",
    body: <Claim />,
    trackTabClickEvent: () => {
      sendLog("Withdraw _Tab");
    },
  },
];

export default stakingTabsData;
